/*
 * @Author: Fone`峰
 * @Date: 2021-02-07 16:01:33
 * @LastEditors: Fone`峰
 * @LastEditTime: 2021-06-21 16:32:30
 * @Description: file content
 * @Email: qinrifeng@163.com
 * @Github: https://github.com/FoneQinrf
 */
/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(Router);

const NEED_ENTER = ["mine", "tenderingL", "tendering"];
const NO_NEED_ENTER = [
  "/mine/index",
  "/mine/baseMsg",
  "/mine/baseDetail",
  "/mine/editPwd",
  "/mine/linkman",
  "/mine/editLinkman",
  "/mine/service",
];

const router = new Router({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

const getQueryString = (name) => {
  // const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};
global.browserQuery = {
  // appid: getQueryString('appid'),
  // cpid: getQueryString('cpid'),
  page: getQueryString("page"),
};

router.beforeEach((to, from, next) => {
  if (global.browserQuery.page) {
    // store.commit('appid', browserQuery.appid);
    // store.commit('cpid', browserQuery.cpid);
    // delete global.browserQuery.appid;
    console.log("page", global.browserQuery.page);
    next();
  }
  const toPath = to.path.split("/")[1]; // ["", "mine", "linkman"]
  if (to.meta.login && !store.state.isLogin) {
    // 未登录情况
    Vue.$vux.toast.text("请先登录");
    store.commit("updateIsPopLogin", true);
    return;
  }
  if (
    store.state.isLogin &&
    store.state.companyStatus === 0 &&
    !NO_NEED_ENTER.includes(to.path) &&
    NEED_ENTER.includes(toPath)
  ) {
    // 未入驻情况
    Vue.$vux.toast.text("请先入驻");
    return;
  }
  /* 用于处理页面底部tabber显示 */
  if (to.meta.showTabber) {
    store.commit("updateShowTabber", true);
  } else {
    store.commit("updateShowTabber", false);
  }
  next();
});

router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (global.browserQuery.page) {
    const p = global.browserQuery.page;
    global.browserQuery = {};
    router.push(p);
  }
});

router.onError((e) => {
  if (e.toString() === "Error: cancel") {
    //
  }
});

export default router;
